export default "__VITE_ASSET__CIoHgIEp__"